import React from 'react';
import PropTypes from 'prop-types';

import OEButton, {OEIconButton} from './oe-button';

export default class OEButtonGroup extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onPressed = this.onPressed.bind(this);
        this.onDisabledPressed = this.onDisabledPressed.bind(this);
        this.onLongPressed = this.onLongPressed.bind(this);
    }

    render() {
        const buttons = this.props.buttons.map((entry, index) =>
            <OEButton
                key={index}
                id={entry.id}
                className={!this.props.children && this.props.buttons.length === index + 1 ? 'last' : ''}
                disabled={this.props.disabled || entry.disabled}
                activated={entry.activated}
                tooltipPlacement={entry.tooltipPlacement}
                tooltip={entry.tooltip}
                disabledTooltip={entry.disabledTooltip}
                onPressed={this.onPressed}
                onDisabledPressed={this.onDisabledPressed}
                onLongPressed={this.props.onLongPressed || entry.onLongPressed ? this.onLongPressed : null} /*there is a problem with Hammer and the ref callback of its first child, we mitigate the problem by not passing onLongPressed, which activates the Hammer render path in OEButton, if it is not needed*/
                elementRef={entry.elementRef}
                longPressTime={entry.longPressTime}
                buttonGroupData={entry}
            >
                {entry.children}
            </OEButton>
        );

        return (
            <div className={'oe-button-group ' + this.props.className}>
                {buttons}
                {this.props.children}
            </div>
        );
    }

    onPressed(e, sender)    {
        if(this.props.onPressed)    this.props.onPressed(this, sender.props.id, e, sender);
        if(sender.props.buttonGroupData.onPressed)  sender.props.buttonGroupData.onPressed(e, sender);
    }

    onDisabledPressed(e, sender)    {
        if(this.props.onDisabledPressed)    this.props.onDisabledPressed(this, sender.props.id, e, sender);
        if(sender.props.buttonGroupData.onDisabledPressed)  sender.props.buttonGroupData.onDisabledPressed(e, sender);
    }

    onLongPressed(e, sender)    {
        if(this.props.onLongPressed)    this.props.onLongPressed(this, sender.props.id, e, sender);
        if(sender.props.buttonGroupData.onLongPressed)  sender.props.buttonGroupData.onLongPressed(e, sender);
    }
}

OEButtonGroup.defaultProps = {
    className:          '',
    disabled:           false
};

OEButtonGroup.propTypes = {
    className:          PropTypes.string,
    disabled:           PropTypes.bool,
    buttons:            PropTypes.arrayOf(PropTypes.shape(OEButton.propTypes)),
    onPressed:          PropTypes.func,
    onDisabledPressed:  PropTypes.func,
    onLongPressed:      PropTypes.func
};

//
export class OEIconButtonGroup extends React.PureComponent {

    constructor(props) {
        super(props);

        this.onPressed = this.onPressed.bind(this);
        this.onDisabledPressed = this.onDisabledPressed.bind(this);
        this.onLongPressed = this.onLongPressed.bind(this);
    }

    render() {
        const buttons = this.props.buttons.map((entry, index) =>
            <OEIconButton
                key={index}
                id={entry.id}
                className={!this.props.children && this.props.buttons.length === index + 1 ? 'last' : ''}
                iconClassName={entry.iconClassName}
                disabled={this.props.disabled || entry.disabled}
                activated={entry.activated}
                icon={entry.icon}
                tooltipPlacement={entry.tooltipPlacement}
                tooltip={entry.tooltip}
                disabledTooltip={entry.disabledTooltip}
                onPressed={this.onPressed}
                onDisabledPressed={this.onDisabledPressed}
                onLongPressed={this.props.onLongPressed || entry.onLongPressed ? this.onLongPressed : null} /*there is a problem with Hammer and the ref callback of its first child, we mitigate the problem by not passing onLongPressed, which activates the Hammer render path in OEButton, if it is not needed*/
                elementRef={entry.elementRef}
                longPressTime={entry.longPressTime}
                buttonGroupData={entry}
            >
                {entry.children}
            </OEIconButton>
        );

        return (
            <div className={'oe-button-group ' + this.props.className}>
                {buttons}
                {this.props.children}
            </div>
        );
    }

    onPressed(e, sender)    {
        if(this.props.onPressed)    this.props.onPressed(this, sender.props.id, e, sender);
        if(sender.props.buttonGroupData.onPressed)  sender.props.buttonGroupData.onPressed(e, sender);
    }

    onDisabledPressed(e, sender)    {
        if(this.props.onDisabledPressed)    this.props.onDisabledPressed(this, sender.props.id, e, sender);
        if(sender.props.buttonGroupData.onDisabledPressed)  sender.props.buttonGroupData.onDisabledPressed(e, sender);
    }

    onLongPressed(e, sender)    {
        if(this.props.onLongPressed)    this.props.onLongPressed(this, sender.props.id, e, sender);
        if(sender.props.buttonGroupData.onLongPressed)  sender.props.buttonGroupData.onLongPressed(e, sender);
    }
}

OEIconButtonGroup.defaultProps = {
    className:          '',
    disabled:           false
};

OEIconButtonGroup.propTypes = {
    className:          PropTypes.string,
    disabled:           PropTypes.bool,
    buttons:            PropTypes.arrayOf(PropTypes.shape(OEIconButton.propTypes)),
    onPressed:          PropTypes.func,
    onDisabledPressed:  PropTypes.func,
    onLongPressed:      PropTypes.func
};